import React, { useState } from "react";
import "./Table.css";

const Table = (props) => {
  const [currentPage, setCurrentPage] = useState(props.currentPage);
  const [itemsPerPage, setItemsPerPage] = useState(props.itemsPerPage);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = props.data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="table-responsive">
      <table
        className="table table-nightspot "
        border="0"
        cellSpacing="0"
        cellPadding="0"
      >
        <thead>
          <tr>
            {props.columns.map((column, index) => (
              <th key={index}>{column}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {currentItems.map((row, index) => (
            <tr key={index}>
              {props.columns.map((column, index) => (
                <td key={index}>{row[column]}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      <Pagination
        itemsPerPage={itemsPerPage}
        totalItems={props.totalItems}
        paginate={paginate}
        currentPage={currentPage}
      />
    </div>
  );
};

const Pagination = (props) => {
  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(props.totalItems / props.itemsPerPage); i++) {
    pageNumbers.push(i);
  }

  return (
    <nav>
      <ul className="pagination">
        {pageNumbers.map((number) => (
          <li
            key={number}
            className={
              props.currentPage === number ? "page-item active" : "page-item"
            }
          >
            <a onClick={() => props.paginate(number)} className="page-link">
              {number}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Table;
